import { render, staticRenderFns } from "./resetPasswordToken.vue?vue&type=template&id=5f0fa697&scoped=true&"
import script from "./resetPasswordToken.vue?vue&type=script&lang=js&"
export * from "./resetPasswordToken.vue?vue&type=script&lang=js&"
import style0 from "./resetPasswordToken.vue?vue&type=style&index=0&id=5f0fa697&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0fa697",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VForm,VImg,VRow,VSnackbar,VTextField})
